import { createEntityAdapter } from '@reduxjs/toolkit';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';

const stagesAdapter = createEntityAdapter<StageV2>({
  selectId: (stage) => stage.id,
  sortComparer: (a, b) => new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf(),
});

export default stagesAdapter;
